import React from 'react';
import { connect } from 'react-redux';
import {
  checkPhoneNumberExpired,
  closePhoneNumberCapture,
  phoneNumberCaptureSubmit,
} from '../../../actionCreators/phoneNumberCapture';
// import PhoneNumberCaptureTop from '../../components/PhoneNumberCapture/PhoneNumberCaptureTop';
import PhoneNumberCaptureBottom from '../../components/PhoneNumberCapture/PhoneNumberCaptureBottom';
import { setWindowDtm } from '../../../utils/DTM';
import localStorageHelper from '../../../utils/localStorageHelper';

class PhoneNumberCapture extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      numberSubmitted: false,
    };
    this.phoneCaptureData = {};
    this.dtm = {};
    // this.closePhoneCapture = this.closePhoneCapture.bind(this);
    this.submitMobileNumber = this.submitMobileNumber.bind(this);
  }

  componentDidMount() {
    const { hasCookieExpired, checkPhoneNumberExpired } = this.props;
    if (hasCookieExpired === null) {
      checkPhoneNumberExpired();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.numberSubmitted !== this.props.numberSubmitted && this.props.numberSubmitted) {
      (() => {
        this.setState({ numberSubmitted: true });
        localStorageHelper.setItem('repeatFlowPhoneCapture', 'true');
        if (this.props?.localeInfo?.countryCode !== 'sg') this.props.handleClose();
      })();
    }
  }

  // closePhoneCapture() {
  //   const { redisCommonData, closePhoneNumberCapture, onCaptureBannerClose } = this.props;
  //   const { NEW_CAPTURE_NUMBER_CLOSE_EXPIRY } = redisCommonData;
  //   if (onCaptureBannerClose) {
  //     onCaptureBannerClose();
  //   }
  //   closePhoneNumberCapture(NEW_CAPTURE_NUMBER_CLOSE_EXPIRY);
  // }

  submitMobileNumber(phone) {
    const { redisCommonData, phoneNumberCaptureSubmit, localeInfo } = this.props;
    const { NEW_CAPTURE_NUMBER_EXPIRY } = redisCommonData;
    const phNo = phone;
    const jsonData = {
      collectionData: [
        {
          phone: phNo,
          created_at: new Date(),
          UTM: window.location.search,
          device_id: 'mobile',
          platform: 'mobilesite',
          is_verified: 0,
          phoneCode: localeInfo.phoneCode,
        },
      ],
    };
    const data = { jsonData, phNo, NEW_CAPTURE_NUMBER_EXPIRY };
    phoneNumberCaptureSubmit(data);
    this.triggerBtnClickDTM('yes');
  }

  triggerBtnClickDTM(flag) {
    const { dtmLinkPageName } = this.props;
    /* DTM */
    const dtm = {};
    dtm.linkName = 'web|sign-up-popup|go';
    dtm.linkPageName = dtmLinkPageName;
    dtm.loginStatus = 'guest';
    dtm.device = 'mobile';
    dtm.site = 'new react';
    dtm.numberEntered = flag;
    dtm.event = 'generic-int-link';
    setWindowDtm(dtm);
    /* DTM */
  }

  render() {
    const {
      page,
      // hasCookieExpired,
      login,
      numberSubmitting,
      numberSubmitError,
      redisCommonData,
      dataLocale,
      localeInfo,
      handleClose,
      userInfo,
    } = this.props;
    const { numberSubmitted } = this.state;
    const {
      APP_DOWNLOAD_ONELINK,
      PHONE_NUMBER_CAPTURE_CONFIG,
      AVAILABLE_NEIGHBOUR_COUNTRIES,
      PHONE_NUMBER_CAPTURE_CONFIG_NEW,
    } = redisCommonData;
    const countryConfig = AVAILABLE_NEIGHBOUR_COUNTRIES
      ? JSON.parse(AVAILABLE_NEIGHBOUR_COUNTRIES)
      : {};
    // let phoneCaptureData = {};
    let phoneCaptureNewData = {};
    if (typeof PHONE_NUMBER_CAPTURE_CONFIG !== 'undefined' && PHONE_NUMBER_CAPTURE_CONFIG) {
      // const captureNumberconfig = JSON.parse(PHONE_NUMBER_CAPTURE_CONFIG);
      // phoneCaptureData = captureNumberconfig[page];
    }
    // For new config
    if (typeof PHONE_NUMBER_CAPTURE_CONFIG_NEW !== 'undefined' && PHONE_NUMBER_CAPTURE_CONFIG_NEW) {
      const captureNumberNewconfig = JSON.parse(PHONE_NUMBER_CAPTURE_CONFIG_NEW);
      phoneCaptureNewData = captureNumberNewconfig[page];
    }
    return (
      <React.Fragment>
        {/* {page !== 'home' ? (
          <PhoneNumberCaptureTop
            appDownloadLink={APP_DOWNLOAD_ONELINK}
            closePhoneCapture={this.closePhoneCapture}
            countryConfig={countryConfig}
            dataLocale={dataLocale}
            hasCookieExpired={hasCookieExpired}
            localeInfo={localeInfo}
            login={login}
            numberSubmitError={numberSubmitError}
            numberSubmitted={numberSubmitted}
            numberSubmitting={numberSubmitting}
            phoneCaptureData={phoneCaptureData}
            submitMobileNumber={this.submitMobileNumber}
          ></PhoneNumberCaptureTop>
        ) : (
          <PhoneNumberCaptureBottom
            appDownloadLink={APP_DOWNLOAD_ONELINK}
            closePhoneCapture={this.closePhoneCapture}
            countryConfig={countryConfig}
            dataLocale={dataLocale}
            hasCookieExpired={hasCookieExpired}
            localeInfo={localeInfo}
            login={login}
            numberSubmitError={numberSubmitError}
            numberSubmitted={numberSubmitted}
            numberSubmitting={numberSubmitting}
            phoneCaptureData={phoneCaptureNewData}
            submitMobileNumber={this.submitMobileNumber}
          ></PhoneNumberCaptureBottom>
        )} */}
        <PhoneNumberCaptureBottom
          hasCookieExpired
          appDownloadLink={APP_DOWNLOAD_ONELINK}
          closePhoneCapture={this.closePhoneCapture}
          countryConfig={countryConfig}
          dataLocale={dataLocale}
          handleClose={handleClose}
          isRepeat={userInfo?.hasPlacedOrder}
          localeInfo={localeInfo}
          login={login}
          numberSubmitError={numberSubmitError}
          numberSubmitted={numberSubmitted}
          numberSubmitting={numberSubmitting}
          phoneCaptureData={phoneCaptureNewData}
          submitMobileNumber={this.submitMobileNumber}
        ></PhoneNumberCaptureBottom>
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    login: state.common.login,
    userInfo: (state.common.userInfo && state.common.userInfo.result) || null,
    redisCommonData: state.common.redisCommonData,
    hasCookieExpired: state.phoneNumberCapture.hasCookieExpired,
    numberSubmitting: state.phoneNumberCapture.numberSubmitting,
    numberSubmitted: state.phoneNumberCapture.numberSubmitted,
    numberSubmitError: state.phoneNumberCapture.numberSubmitError,
    dataLocale: state.locale,
    localeInfo: state.common.localeInfo,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    checkPhoneNumberExpired: () => dispatch(checkPhoneNumberExpired()),
    closePhoneNumberCapture: expiry => dispatch(closePhoneNumberCapture(expiry)),
    phoneNumberCaptureSubmit: data => dispatch(phoneNumberCaptureSubmit(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PhoneNumberCapture);
